import React, { useState } from "react";
import "../../styles/Works/Works.scss";
import "../../styles.css"; // Import the generalized CSS styles

import data from "../../data";
import ProjectCard from "../ProjectCard";

const Works = ({ darkTheme }) => {
  const text = "WORKS.";
  const [hoveredIndices, setHoveredIndices] = useState(new Set());

  const handleMouseOver = (index) => {
    setHoveredIndices((prev) => new Set(prev.add(index)));
  };

  const handleMouseOut = (index) => {
    // Optional: Remove this function if you want to keep the hover effect persistent
  };

  return (
    <div className={`works ${darkTheme ? "dark" : "light"}`} id="work">
      <div className="works__container">
        <div className="works__header" id="works__heading">
          <h1 data-aos="fade-down" className="text-wrapper">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className={hoveredIndices.has(index) ? "gradient-text" : ""}
                onMouseOver={() => handleMouseOver(index)}
                onMouseOut={() => handleMouseOut(index)} // Optional: Remove this if you don't need to reset hover
                style={{ color: darkTheme ? "white" : "black" }}
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </h1>
        </div>
        <div className="works__grid">
          <div className="works__grid-container">
            {data.portfolio.projectCard.cards.map((content) => (
              <ProjectCard
                key={content.heading}
                cardContent={content}
                darkTheme={darkTheme}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Works;
